exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UserImproveBox__buttonLine___XjX5l {\n\ttext-align: right;\n}\n\n.UserImproveBox__addButton___1laZ7 {\n\tpadding-right: 0.33rem!important;\n}\n", ""]);

// exports
exports.locals = {
	"buttonLine": "UserImproveBox__buttonLine___XjX5l",
	"addButton": "UserImproveBox__addButton___1laZ7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/User/UserImproveBox.icss
// module id = 1576
// module chunks = 0